import React, { useEffect, useRef, useState } from "react";
import { Container, Dropdown, DropdownButton, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import "./Order.css";
import { SendOrderAction } from "../Redux/OrderRedux";
import { Toast } from "primereact/toast";
import OrderDetail from "./OrderDetail";
import { RequestOrderDetails } from "../Redux/OrderDetailRedux";

function Order() {
  const dispatch = useDispatch();
  const toast = useRef(null);
  const [viewBox, setViewBox] = useState({ Hide: false });
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const posts = useSelector((state) => state.Order);
  const showSuccess = (Message, Summary) => {
    toast.current.show({
      severity: "success",
      summary: Summary,
      detail: Message,
      life: 3000,
    });
  };

  useEffect(() => {
    dispatch(SendOrderAction(["None", 0]));
    setWindowDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }, [dispatch]);

  const HandelDetailView = async (OrderNo) => {
    await dispatch(RequestOrderDetails(OrderNo));
    setViewBox({ Hide: true });
  };

  const HandelMoveRemove = async (Action, OrderNo) => {
    await dispatch(SendOrderAction([Action, OrderNo]));
    if (Action === "RMV") {
      showSuccess("Order Has Been Canceled", "Order Removed");
    } else {
      showSuccess(
        "Order and Address Has been Moved to Your Cart",
        "Order Moved"
      );
    }
  };

  return (
    <Container fluid="xl" className="Cointainer02">
      <Toast ref={toast} position="bottom-center" />
      <div className={posts.isFilled + " Div01"}>
        <Table hover>
          {windowDimensions["width"] > 800 ? (
            <>
              <thead>
                <tr className="Header">
                  <td>OrderNo</td>
                  <td>OrderList</td>
                  <td>OrderStatus</td>
                  <td>PaymentStatus</td>
                  <td>TotalPayment</td>
                  <td>Address</td>
                  <td>Actions</td>
                </tr>
              </thead>
              <tbody>
                {posts.data?.map((post) => (
                  <tr key={"a" + post.OrderNo}>
                    <td className="TextFrame02">
                      <strong>{post.OrderNo}</strong>
                    </td>
                    <td className="TextFrame02">
                      {post.OrderList.split(",").map((item) => (
                        <div key={item}>
                          <p className="TextFrame02">{item}</p>
                        </div>
                      ))}
                    </td>

                    <td className="TextFrame02">{post.OrderStatus}</td>

                    <td className="TextFrame02">{post.PaymentStatus}</td>

                    <td className="TextFrame02">{post.TotalPayment}</td>

                    <td className="TextFrame02">
                      <DropdownButton
                        id="dropdown-variants-Secondary"
                        variant="Secondary"
                        title="Address Details"
                      >
                        <Dropdown.Item>{post.Name}</Dropdown.Item>
                        <Dropdown.Item>{post.Address}</Dropdown.Item>
                        <Dropdown.Item>{post.Landmark}</Dropdown.Item>
                        <Dropdown.Item>{post.State}</Dropdown.Item>
                        <Dropdown.Item>{post.City}</Dropdown.Item>
                        <Dropdown.Item>{post.PinCode}</Dropdown.Item>
                        <Dropdown.Item>{post.MobileNo}</Dropdown.Item>
                      </DropdownButton>
                    </td>

                    <td className="FilterBar06">
                      {post.OrderStatus === "Pending" ? (
                        <>
                          {posts.isLoading === "hide" ? (
                            <>
                              <p
                                className="TextStyle02"
                                onClick={() =>
                                  HandelMoveRemove("B2B", post.OrderNo)
                                }
                              >
                                Move to Cart
                              </p>
                            </>
                          ) : (
                            <p className="TextStyle02">Move to Cart</p>
                          )}
                        </>
                      ) : null}

                      {post.OrderStatus === "Pending" ? (
                        <>
                          {posts.isLoading === "hide" ? (
                            <>
                              <p
                                className="TextStyle02"
                                onClick={() =>
                                  HandelMoveRemove("RMV", post.OrderNo)
                                }
                              >
                                Cancel
                              </p>
                            </>
                          ) : (
                            <p className="TextStyle02">Cancel</p>
                          )}
                        </>
                      ) : null}

                      {posts.isLoading === "hide" ? (
                        <>
                          <p
                            className="TextStyle02"
                            onClick={() => HandelDetailView(post.OrderNo)}
                          >
                            Detail View
                          </p>
                        </>
                      ) : (
                        <p className="TextStyle02">Detail View</p>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </>
          ) : (
            <>
              <thead>
                <tr className="Header">
                  <td>OrderNo/OrderLists</td>
                  <td>All Status</td>
                  <td>Actions</td>
                </tr>
              </thead>

              <tbody>
                {posts.data?.map((post) => (
                  <tr key={"a" + post.OrderNo}>
                    <td className="FilterBar06">
                      <strong>{"OrderNo: " + post.OrderNo}</strong>

                      <div className="FilterBar06">
                        {post.OrderList.split(",").map((item) => (
                          <div key={item}>
                            <p className="TextFrame02">{item}</p>
                          </div>
                        ))}
                      </div>
                    </td>
                    <td className="TextFrame02">
                      <div>
                        <strong>OrderStatus</strong>
                        <br></br>
                        {post.OrderStatus}
                      </div>
                      <div>
                        <strong>PaymentStatus</strong>
                        <br></br>
                        {post.PaymentStatus}
                      </div>
                      <div>
                        <strong>TotalPayment</strong>
                        <br></br>
                        {post.TotalPayment}
                      </div>
                      <div>
                        <DropdownButton
                          id="dropdown-variants-Secondary"
                          variant="Secondary"
                          title="Address Details"
                        >
                          <Dropdown.Item>{post.Name}</Dropdown.Item>
                          <Dropdown.Item>{post.Address}</Dropdown.Item>
                          <Dropdown.Item>{post.Landmark}</Dropdown.Item>
                          <Dropdown.Item>{post.State}</Dropdown.Item>
                          <Dropdown.Item>{post.City}</Dropdown.Item>
                          <Dropdown.Item>{post.PinCode}</Dropdown.Item>
                          <Dropdown.Item>{post.MobileNo}</Dropdown.Item>
                        </DropdownButton>
                      </div>
                    </td>

                    <td className="FilterBar06">
                        {post.OrderStatus === "Pending" ? (
                          <>
                            {posts.isLoading === "hide" ? (
                              <>
                                <p
                                  className="TextStyle02"
                                  onClick={() =>
                                    HandelMoveRemove("B2B", post.OrderNo)
                                  }
                                >
                                  Move_to_Cart
                                </p>
                              </>
                            ) : (
                              <p className="TextStyle02">Move_to_Cart</p>
                            )}
                          </>
                        ) : null}
                      {post.OrderStatus === "Pending" ? (
                        <>
                          {posts.isLoading === "hide" ? (
                            <>
                              <p
                                className="TextStyle02"
                                onClick={() =>
                                  HandelMoveRemove("RMV", post.OrderNo)
                                }
                              >
                                Cancel
                              </p>
                            </>
                          ) : (
                            <p className="TextStyle02">Cancel</p>
                          )}
                        </>
                      ) : null}
                      {posts.isLoading === "hide" ? (
                        <>
                          <p
                            className="TextStyle02"
                            onClick={() => HandelDetailView(post.OrderNo)}
                          >
                            Detail_View
                          </p>
                        </>
                      ) : (
                        <p className="TextStyle02">Detail_View</p>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </>
          )}
        </Table>
      </div>

      {/* {posts.isLoading && (
        <div className="Loading04 d-flex justify-content-center ">
          <Spinner animation="border" variant="secondary" />
        </div>
      )} */}

      <div className={posts.isEmpty + " d-flex justify-content-center"}>
        <h1>Your Order Is Empty</h1>
      </div>

      <OrderDetail
        show={viewBox.Hide}
        onHide={() => setViewBox({ Hide: false })}
      />
    </Container>
  );
}

export default Order;
